/*
 * KLOKI cart drawer UI — upsell, slevový kód, poznámka, souhlas s podmínkami.
 *
 * POZOR na životní cyklus: obsah draweru se překresluje SERVER-SIDE hned dvěma cestami —
 *   1) window.KlokiCart.open() (CartDrawer.renderContents → přepíše #CartDrawer),
 *   2) nativní cart.js při změně množství (CartDrawerItems → přepíše .drawer__inner).
 * Proto jsou VŠECHNY posluchače delegované na document (přežijí překreslení) a stav,
 * který v HTML není (načtený upsell, zaškrtnutý souhlas), se obnovuje v init() přes
 * MutationObserver.
 */
(function () {
  var TERMS_KEY = 'kloki_cart_terms_ok';
  var upsellCache = {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }
  function updateUrl() {
    var u = (window.routes && window.routes.cart_update_url) || '/cart/update';
    return u.indexOf('.js') > -1 ? u : u + '.js';
  }
  function refreshDrawer() {
    if (window.KlokiCart && typeof window.KlokiCart.open === 'function') window.KlokiCart.open();
  }

  /* ── Pozice scrollu přes překreslení ──────────────────────────── */
  // Každá akce uvnitř draweru (množství, odebrání, upsell, dýško) překreslí obsah
  // server-side a scroller se tím vrátí na začátek — kdo je dole u upsellu, vyskočí
  // nahoru a musí scrollovat znovu. Pozici si proto před akcí zapamatujeme a po
  // překreslení vrátíme. Razítko brání tomu, aby se stará pozice uplatnila při
  // příštím otevření draweru, kdyby překreslení nikdy nepřišlo.
  var keepTop = null;
  var keepAt = 0;
  function scroller() { return document.querySelector('cart-drawer-items'); }
  function rememberScroll() {
    var sc = scroller();
    if (!sc) return;
    keepTop = sc.scrollTop;
    keepAt = Date.now();
  }
  function restoreScroll() {
    if (keepTop === null) return;
    var top = keepTop;
    var fresh = Date.now() - keepAt < 3000;
    keepTop = null;
    if (!fresh || !top) return;
    var sc = scroller();
    if (!sc) return;
    sc.scrollTop = Math.min(top, sc.scrollHeight);
  }

  /* ── Souhlas s obchodními podmínkami ──────────────────────────── */
  function termsRequired() { return !!$('[data-kcart-terms]'); }
  function termsAccepted() {
    try { return sessionStorage.getItem(TERMS_KEY) === '1'; } catch (e) { return false; }
  }
  function setTermsAccepted(v) {
    try { sessionStorage.setItem(TERMS_KEY, v ? '1' : '0'); } catch (e) {}
  }
  function cartEmpty() {
    var d = document.querySelector('cart-drawer');
    return !d || d.classList.contains('is-empty');
  }
  function syncTerms() {
    var box = $('[data-kcart-terms]');
    var btn = $('#CartDrawer-Checkout');
    if (box) box.checked = termsAccepted();
    if (btn) {
      // Skutečný disabled = jediná spolehlivá blokace odeslání formuláře.
      btn.disabled = cartEmpty() || (termsRequired() && !termsAccepted());
    }
    var warn = $('[data-kcart-terms-warn]');
    if (warn && termsAccepted()) warn.hidden = true;
  }
  function nudgeTerms() {
    if (!termsRequired() || termsAccepted()) return;
    var warn = $('[data-kcart-terms-warn]');
    if (warn) warn.hidden = false;
    var row = $('[data-kcart-terms-row]');
    if (row) {
      row.classList.remove('kcart-terms--nudge');
      void row.offsetWidth;
      row.classList.add('kcart-terms--nudge');
    }
    var box = $('[data-kcart-terms]');
    if (box) box.focus();
  }

  /* ── Upsell (server-side render přes Recommendations API) ─────── */
  function loadUpsell() {
    var host = $('[data-kcart-upsell]');
    if (!host || host.dataset.loaded === '1') return;
    var url = host.dataset.url;
    if (!url) return;

    function inject(html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var block = parsed.querySelector('.kcart-upsell');
      host.innerHTML = block ? block.outerHTML : '';
      host.dataset.loaded = '1';
    }

    if (upsellCache[url] !== undefined) { inject(upsellCache[url]); return; }

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        // Bez nastavených komplementárních produktů vrátí API prázdno → zkusíme "related".
        if (html.indexOf('kcart-upsell') === -1 && url.indexOf('intent=complementary') > -1) {
          var alt = url.replace('intent=complementary', 'intent=related');
          return fetch(alt, { credentials: 'same-origin' }).then(function (r) { return r.text(); });
        }
        return html;
      })
      .then(function (html) { upsellCache[url] = html; inject(html); })
      .catch(function () { host.dataset.loaded = '1'; });
  }

  function addUpsell(btn) {
    var id = parseInt(btn.dataset.variantId, 10);
    if (!id || btn.disabled) return;
    btn.disabled = true;
    rememberScroll();
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url + '.js' : '/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Cart add failed');
          return data;
        });
      })
      .then(function () {
        btn.textContent = btn.dataset.addedLabel || btn.textContent;
        refreshDrawer();
      })
      .catch(function () { btn.disabled = false; });
  }

  /* ── Dýško baliči ─────────────────────────────────────────────── */
  // Klik na částku = přidat, klik na vybranou = odebrat, jiná částka = výměna.
  // Jde přes /cart/update.js s VARIANT ID (ne s line key), takže i výměna je
  // jediný atomický požadavek. Nulují se VŠECHNY nabízené částky naráz, čímž se
  // spraví i stav, kdy by v košíku z dřívějška uvázly dvě částky současně.
  function tipChoose(btn) {
    var wrap = btn.closest('.kcart-tip');
    if (!wrap || wrap.classList.contains('is-busy')) return;
    var id = parseInt(btn.dataset.variantId, 10);
    if (!id) return;

    var active = btn.getAttribute('aria-pressed') === 'true';
    var updates = {};
    var opts = wrap.querySelectorAll('[data-kcart-tip]');
    for (var i = 0; i < opts.length; i++) {
      var oid = parseInt(opts[i].dataset.variantId, 10);
      if (oid) updates[oid] = 0;
    }
    if (!active) updates[id] = 1;

    wrap.classList.add('is-busy');
    rememberScroll();
    fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Tip update failed');
          return data;
        });
      })
      .then(function () {
        if (window.KlokiCart && window.KlokiCart.invalidateCart) window.KlokiCart.invalidateCart();
        refreshDrawer();
      })
      .catch(function () { wrap.classList.remove('is-busy'); });
  }

  /* ── Slevový kód ──────────────────────────────────────────────── */
  function applyDiscount(btn) {
    var wrap = btn.closest('[data-kcart-code]');
    var input = wrap && wrap.querySelector('.kcart-code__input');
    var msg = wrap && wrap.querySelector('[data-kcart-code-msg]');
    var code = input && input.value.trim();
    if (!code) return;

    btn.disabled = true;
    if (msg) { msg.hidden = true; msg.textContent = ''; }

    var before = 0;
    fetch(cartUrl() + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        before = (c.cart_level_discount_applications || []).length + (c.total_discount || 0);
        // /discount/<kod> uplatní kód do session a přesměruje; nás zajímá jen efekt na košík.
        // ?redirect= míří na cart.js — bez něj přesměruje na homepage a fetch ji
        // celou stáhne (naměřeno 1,65 MB / ~1 000 ms proti 3 kB / ~650 ms).
        return fetch('/discount/' + encodeURIComponent(code) +
                     '?redirect=' + encodeURIComponent(cartUrl() + '.js'),
                     { credentials: 'same-origin' });
      })
      .then(function () { return fetch(cartUrl() + '.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var after = (c.cart_level_discount_applications || []).length + (c.total_discount || 0);
        if (after > before) {
          if (input) input.value = '';
          refreshDrawer();
        } else if (msg) {
          msg.hidden = false;
          msg.textContent = msg.dataset.errText || '';
        }
      })
      .catch(function () {
        if (msg) { msg.hidden = false; msg.textContent = msg.dataset.errText || ''; }
      })
      .finally(function () { btn.disabled = false; });
  }

  /* ── Změna varianty přímo v košíku ────────────────────────────── */
  // Shopify nemá „změnit variantu" — jde jen odebrat starou a přidat novou.
  // U běžných řádků: atomický /cart/update.js.
  // U dárků s _gift_choice: zachovat properties přes change(key→0) + add s props.
  function changeVariant(sel) {
    var oldId = sel.getAttribute('data-current');
    var newId = sel.value;
    var qty = parseInt(sel.getAttribute('data-qty'), 10) || 1;
    if (!newId || newId === oldId) return;

    sel.disabled = true;

    var giftGroup = sel.getAttribute('data-gift-group');
    var lineKey = sel.getAttribute('data-line-key');

    var done = function () { refreshDrawer(); };
    var fail = function () { sel.disabled = false; sel.value = oldId; };

    if (giftGroup && lineKey) {
      var props = {
        _gift_group: giftGroup,
        _gift_of: '1',
        _gift_lock: '1',
        _gift_choice: '1'
      };
      fetch(cartUrl() + '/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Cart change failed');
            return data;
          });
        })
        .then(function () {
          return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url + '.js' : '/cart/add.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: parseInt(newId, 10), quantity: qty, properties: props }] })
          });
        })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Cart add failed');
            return data;
          });
        })
        .then(function () {
          if (window.KlokiGifts && typeof window.KlokiGifts.syncFromServer === 'function') {
            return window.KlokiGifts.syncFromServer();
          }
        })
        .then(done)
        .catch(fail);
      return;
    }

    var updates = {};
    updates[oldId] = 0;
    updates[newId] = qty;

    fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Variant change failed');
          return data;
        });
      })
      .then(function () {
        if (window.KlokiCart && window.KlokiCart.invalidateCart) window.KlokiCart.invalidateCart();
        refreshDrawer();
      })
      .catch(function () {
        // Vrátit výběr zpět, ať uživatel nevidí variantu, která se neuložila.
        sel.value = oldId;
        sel.disabled = false;
        var errors = document.getElementById('CartDrawer-CartErrors');
        if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
      });
  }

  /* ── Poznámka k objednávce ────────────────────────────────────── */
  var noteTimer = null;
  function saveNote(value) {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(updateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: value })
      }).catch(function () {});
    }, 600);
  }

  /* ── Delegované posluchače (přežijí překreslení) ──────────────── */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-kcart-toggle]');
    if (toggle) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) {
        panel.hidden = open;
        // Panel se rozbaluje na konci scrollovací oblasti, takže by zůstal schovaný
        // pod sticky patičkou. scrollIntoView tu byl nespolehlivý (měřeno živě) —
        // posuneme oblast natvrdo na konec, panel je její poslední obsah.
        if (!open) {
          var scroller = document.querySelector('cart-drawer-items');
          var reveal = function () {
            if (scroller) scroller.scrollTop = scroller.scrollHeight;
          };
          requestAnimationFrame(function () {
            reveal();
            // Druhý průchod po dopočítání layoutu (panel mění výšku obsahu).
            setTimeout(reveal, 120);
            var field = panel.querySelector('input, textarea');
            if (field) field.focus({ preventScroll: true });
          });
        }
      }
      return;
    }
    var tip = e.target.closest('[data-kcart-tip]');
    if (tip) { tipChoose(tip); return; }

    var add = e.target.closest('[data-kcart-upsell-add]');
    if (add) { addUpsell(add); return; }

    var apply = e.target.closest('[data-kcart-code-apply]');
    if (apply) { applyDiscount(apply); return; }
  });

  // Ikona košíku v hlavičce: nativní Dawn drawer jen otevře s POSLEDNÍM vykresleným
  // obsahem (CartDrawer.open() nic nenačítá), takže po změně košíku jinou cestou ukáže
  // zastaralý stav. Capture fáze předběhne Dawn listener a otevřeme přes helper,
  // který si sekce nejdřív refetchne. Bez JS zůstává odkaz na /cart jako fallback.
  document.addEventListener('click', function (e) {
    var icon = e.target.closest('#cart-icon-bubble');
    if (!icon) return;
    if (!window.KlokiCart || typeof window.KlokiCart.open !== 'function') return;
    e.preventDefault();
    e.stopPropagation();
    window.KlokiCart.open();
  }, true);

  // Množství a odebrání obsluhuje nativní cart.js, který si sám překreslí .drawer__inner.
  // Nemáme se kam zavěsit, takže si pozici uložíme už při kliku.
  document.addEventListener('click', function (e) {
    if (e.target.closest('cart-drawer .quantity__button, cart-drawer .cart-remove-button')) {
      rememberScroll();
    }
  }, true);

  // Zakázané tlačítko klik nedostane (pointer-events:none) → chytá ho obal a vyzve k souhlasu.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-kcart-checkout-wrap]')) nudgeTerms();
  });

  // Druhá pojistka pro odeslání formuláře jinou cestou (Enter v poli apod.).
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'CartDrawer-Form' && termsRequired() && !termsAccepted()) {
      e.preventDefault();
      nudgeTerms();
    }
  }, true);

  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-kcart-terms]');
    if (box) { setTermsAccepted(box.checked); syncTerms(); return; }
    var variant = e.target.closest('[data-kcart-variant]');
    if (variant) changeVariant(variant);
  });

  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-kcart-note]');
    if (note) saveNote(note.value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('.kcart-code__input');
    if (!input) return;
    e.preventDefault();
    var btn = input.closest('[data-kcart-code]').querySelector('[data-kcart-code-apply]');
    if (btn) applyDiscount(btn);
  });

  /* ── Init + reakce na překreslení draweru ─────────────────────── */
  function init() { loadUpsell(); syncTerms(); restoreScroll(); }

  var pending = null;
  function scheduleInit() {
    clearTimeout(pending);
    pending = setTimeout(init, 60);
  }

  function observe() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(scheduleInit).observe(drawer, { childList: true, subtree: true });
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
